
  export default {
    hydrate(data: any, container: HTMLElement) {
      const React = require('react');
      const ReactDOMClient = require('react-dom/client');
      const { default: Component } = require('/app/src/components/region-redirect-banner/RegionRedirectBanner');
      ReactDOMClient.hydrateRoot(container, <Component {...data} />);
    },
  };
